import React, { useState, useRef, useEffect } from "react";
import { RiArrowUpDownFill } from "react-icons/ri";
import { FaFileInvoice, FaRegEye, FaFileDownload } from "react-icons/fa";
import { PiCertificateFill } from "react-icons/pi";
import Tooltip from "../../components/Tooltip";
import { giveTextColor } from "../../helpers/textColors";
import { IoReceipt } from "react-icons/io5";
import { MdExpandLess, MdExpandMore, MdOutlinePayment } from "react-icons/md";
import "./Billings.css";
import axios from "axios";
import SmallLoader from "../../components/SmallLoader.js";
import { useNavigate } from "react-router-dom";
import constant from "../../constant/constant.js";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { logout } from "../../store/authSlice.js";


const billingData = [
  {
    groupName: "Small RPC (1-2-234)",
    coursePendingAmt: "2,000",
    courseBillings: [
      {
        date: "25 Mar 2024",
        courseName: "Small RPC",
        courseFee: "10,000",
        modeOfPayment: "Cash",
        paidAmount: "80",
        discount: "1,000",
        pendingAmount: "10",
        downloadReceipt: "link_to_receipt_A",
        invoice: "link_to_invoice_A",
      },
      {
        date: "25 Jun 2024",
        courseName: "Small RPC",
        courseFee: "150",
        modeOfPayment: "UPI",
        paidAmount: "150",
        discount: "0",
        pendingAmount: "0",
        downloadReceipt: "link_to_receipt_B",
        invoice: "link_to_invoice_B",
      },
    ],
  },
  {
    groupName: "Medium RPC (2-3-456)",
    courseBillings: [
      {
        date: "25 Aug 2024",
        courseName: "Medium RPC",
        courseFee: "200",
        modeOfPayment: "Credit Card",
        paidAmount: "180",
        discount: "20",
        pendingAmount: "0",
        downloadReceipt: "link_to_receipt_C",
        invoice: "link_to_invoice_C",
      },
    ],
  },
];

const Billings = () => {
  const user = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [autoLoader, setAutoLoader] = useState(false);
  const [dataStatus, setDataStatus] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(null);
  const [courseBillingRecord, setCourseBillingRecord] = useState([]);
  const viewRef = useRef(null);
  const downloadRef = useRef(null);

  const formatter = new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

  const [expanded, setExpanded] = useState(null);

  const toggleExpanded = (index) => {
    setExpanded(expanded === index ? null : index);
  };

  const dropdownRef = useRef(null);
  const toggleDropdown = (index, type) => {
    const key = `${index}-${type}`;
    setDropdownOpen(dropdownOpen === key ? null : key);
  };

  const isDropdownOpen = (index, type) => {
    return dropdownOpen === `${index}-${type}`;
  };
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target) && !viewRef.current?.contains(event.target) && !downloadRef.current?.contains(event.target)) {
      setDropdownOpen(null);
    }
  };

  useEffect(() => {
  
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
    
  }, []);

   const [sortConfig, setSortConfig] = useState({});
   const [activeColumn, setActiveColumn] = useState(null);

  const sortedData = (index) => {
    let sortableItems = [...courseBillingRecord[index].courseBillings];
    const config = sortConfig[index] || { key: 'date', direction: 'ascending' };

    if (config) {
      sortableItems.sort((a, b) => {
        const aValue = config.key === 'paidAmount' || config.key === 'courseFee' || config.key === 'discount'
          ? parseFloat(a[config.key])
          : a[config.key];
        
        const bValue = config.key === 'paidAmount' || config.key === 'courseFee' || config.key === 'discount'
          ? parseFloat(b[config.key])
          : b[config.key];

        if (aValue < bValue) {
          return config.direction === 'ascending' ? -1 : 1;
        }
        if (aValue > bValue) {
          return config.direction === 'ascending' ? 1 : -1;
        }
        return 0;
      });
    }

    return sortableItems;
  };

  const requestSort = (index, key) => {
    setActiveColumn(index+key);
    let direction = 'ascending';
    const currentConfig = sortConfig[index] || {};

    if (currentConfig.key === key && currentConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig(prevConfig => ({
      ...prevConfig,
      [index]: { key, direction }
    }));
  };
  
useEffect(() =>{
  getcourselist();
},[])

  const checkUserLogin = (response) => {
    if (response.data.login.status === 0) {
      dispatch(logout());
      navigate("/login");
    }
  };

  const getcourselist = async () => {
    setAutoLoader(true);
    axios({
      method: "post",
      url: `${constant.base_url}/student/student_doc_billing.php?fun=getstcoursehis`,
      headers: { "Auth-Id": user.auth_id },
      data: { },
    }).then(function (response) {
        checkUserLogin(response);
        if (response.data.data.status === "1") {
          setCourseBillingRecord([...response.data.data.list]);
          setDataStatus(true);
        } else {
          setCourseBillingRecord([]);
        }
        setAutoLoader(false);
        setDataStatus(true);
      })
      .catch(function (error) {
        console.error("Error during login:", error);
      });
  };
  const sendreciptmail = async (receiptId,type) =>{
    axios({
      method: "post",
      url: `${constant.base_url}/student/student_doc_billing.php?fun=sendreciptmail`,
      headers: { "Auth-Id": user.auth_id },
      data: {
        receiptId: receiptId,
      },
    })
      .then(function (response) {
        checkUserLogin(response);
        if (response.data.data.status) {
          setDropdownOpen(null);
          toast.success(response.data.data.msg);
        } else {
          toast.error(response.data.data.msg);
        }
      })
      .catch(function (error) {
        console.error("Error during login:", error);
      });
  }
  const sendinvoicemail = async (invoiceId,type) =>{
    axios({
      method: "post",
      url: `${constant.base_url}/student/student_doc_billing.php?fun=sendinvoicemail`,
      headers: { "Auth-Id": user.auth_id },
      data: {
        invoiceId: invoiceId,
      },
    }).then(function (response) {
        checkUserLogin(response);
        if (response.data.data.status) {
          setDropdownOpen(null);
          toast.success(response.data.data.msg);
        } else {
          toast.error(response.data.data.msg);
        }
      })
      .catch(function (error) {
        console.error("Error during login:", error);
      });
  }
  const getReceiptPdfUrl = async (receiptId,type) => {
    axios({
      method: "post",
      url: `${constant.base_url}/student/student_doc_billing.php?fun=getReceiptPdf`,
      headers: { "Auth-Id": user.auth_id },
      data: {
        receiptId: receiptId,
      },
    })
      .then(function (response) {
        checkUserLogin(response);
        if (response.data.data.status) {
          if (response.data.data.payment_file_name) {
            setDropdownOpen(null);
            if(type==='view'){
              window.open(
                constant.invoicepdfurl + response.data.data.payment_file_name
              );
            }else{
              toast.success(response.data.data.msg);
              handleDownloadReceiptFile(constant.invoicepdfurl + response.data.data.payment_file_name);
            }
            
          }
        } else {
          toast.error(response.data.data.msg);
        }
      })
      .catch(function (error) {
        console.error("Error during login:", error);
      });
    };  
   //==================Course Api Request==================
   
   const getInvoicePdfUrl = async (invoiceId,type) => {
    axios({
      method: "post",
      url: `${constant.base_url}/student/student_doc_billing.php?fun=getInvoicePdf`,
      headers: { "Auth-Id": user.auth_id },
      data: {
        invoiceId: invoiceId,
      },
    }).then(function (response) {
        checkUserLogin(response);
        if (response.data.data.status) {
          if(response.data.data.invoice_file_name){
            setDropdownOpen(null);
            if(type==='view'){
              window.open(constant.invoicepdfurl + response.data.data.invoice_file_name);
            }
            else{
              toast.success(response.data.data.msg);
              handleDownloadReceiptFile(constant.invoicepdfurl + response.data.data.invoice_file_name);
            }
          }
          
          
        } else {
          toast.error(response.data.data.msg);
        }
      })
      .catch(function (error) {
        console.error("Error during login:", error);
      });
   };
  const handleDownloadReceiptFile = async (filelink) => {
    try {
      // Fetch the file from the provided link
      const response = await fetch(filelink);
      if (!response.ok) {
        throw new Error('Network response was not ok.');
      }

      // Convert the response to a Blob
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      // Create an anchor element and trigger the download
      const anchor = document.createElement('a');
      anchor.href = url;
      anchor.download = ''; // Optionally specify a filename here
      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);

      // Clean up the URL object
      window.URL.revokeObjectURL(url);
      
    } catch (error) {
      console.error('There was a problem with the fetch operation:', error);
    }
    setDropdownOpen(null);
  };
  

  //==================Course Api Request==================

  const paypendingamount = async (wo_id) => {
    axios({
      method: "post",
      url: `${constant.base_url}/student/student_doc_billing.php?fun=paypendingamount`,
      headers: { "Auth-Id": user.auth_id },
      data: {"wo_id":wo_id},
    }).then(function (response) {
        checkUserLogin(response);
        if (response.data.data.status==="1") {
            window.open(response.data.data.paymentlink);
        } else {
          toast.error(response.data.data.msg);
        }
      })
      .catch(function (error) {
        console.error("Error during login:", error);
      });
   };

   const handleDownloadCertificate = async (work_order_id) => {
    axios({
      method: "post",
      url: `${constant.base_url}/student/student_doc_billing.php?fun=downloadcertificate`,
      headers: { "Auth-Id": user.auth_id },
      data: {"wo_id":work_order_id},
    }).then(function (response) {
        checkUserLogin(response);
        if (response.data.data.status === "1") {
            // Assuming certificate_file_name is an array
            response.data.data.certificate_file_name.forEach(file => {
                handleDownloadReceiptFile(constant.invoicepdfurl + file);
            });
        } else {
            toast.error(response.data.data.msg);
        }
      })
      .catch(function (error) {
        console.error("Error during login:", error);
      });
   }

  return (
    <>
      {dataStatus && (
    <div className="course-container lings-container df mr20 settings">
      <div className="w100">
        <div className="account-details df fdc">
          <div className="settings-head">
            <h3 className="fc3 fw5 fs18 mt12 mb12">
              Billing
              <div className="fs14 fc16 mt8 fw4 fc6 lh18">
                Manage your payments, and download receipts and invoices for
                your records. Keep track of all your billing details in one
                place.
              </div>
            </h3>
          </div>
        </div>

        {courseBillingRecord.map((billingGroup, index) => (
          <div
            className="course-billing brd-b2 mt24 w100"
            key={index}
          >
            {billingGroup.courseBillings && billingGroup.courseBillings.length > 0 && (
              <>
                <div className="bill-head df aic jcsb">
                  <p className="fs14 fc8 ls1 lh22 fw6">
                    {billingGroup.groupName}
                  </p>
                  {billingGroup.workorder_status === 'reject' ? (
                    <div className="v-center pending-amt">
                      <p className="fs14 fc5 ls1 lh22 fw6 mr16">Rejected</p>
                    </div>
                  ) : billingGroup.coursePendingAmt > 0 ? (
                    <div className="v-center pending-amt ">
                      <p className="fs14 fc5 ls1 lh22 fw6 mr16">
                        Pending Amount: {formatter.format(billingGroup.coursePendingAmt)}{" "}
                      </p>
                      <p className="fs12 ls1 lh22 fw6  bg-outline-info badge badge-status cp v-center" onClick={()=>paypendingamount(billingGroup.wo_id)}>
                        <MdOutlinePayment className="mr4" /> Pay Now
                      </p>
                    </div>
                  ) : ''}
                  
                  {/* {billingGroup.course_certificate>0 && (
                     <span className="fs12 ls1 lh22 fw6  bg-outline-success badge badge-status cp v-center" onClick={() => handleDownloadCertificate(billingGroup.wo_id)}>
                     <PiCertificateFill className="fs14"
                      />{" "}
                     Certificate
                   </span>
                  )} */}
                </div>
                <div
                  className="joinde-course-list bill-container"
                  
                >
                  <table className="w100 mt16 tac wsnw">
                    <thead>
                      <tr>
                        <th className="cp" >
                        <p className={`${activeColumn && activeColumn === index+'date'?"fc3" : "fc2"} box-center`}>
                        Last Payment Date
                           
                        </p>
                        </th>
		    {billingGroup.discount > 0 && 
			<>
			 <th  className="cp">
                        <p className={`${activeColumn && activeColumn === index+'courseName'?"fc3" : "fc2"} box-center`}>
                        Course MRP
                           
                          </p>
                        </th>
                        <th className="cp">
                        <p className={`${activeColumn && activeColumn === index+'courseFee'?"fc3" : "fc2"} box-center`}>
                        Discount
                           
                          </p>
                        </th>
			</>
		     }
                        <th  className="cp">
                        <p className={`${activeColumn && activeColumn === index+'paidAmount'?"fc3" : "fc2"} box-center`}>
                        Total Price
                           
                          </p>
                        </th>
                        <th className="cp">
                        <p className={`${activeColumn && activeColumn === index+'discount'?"fc3" : "fc2"} box-center`}>
                        Total Paid
                            
                          </p>
                        </th>
                        {billingGroup.pendingAmount>0  &&<th className="cp">
                        <p className={`${activeColumn && activeColumn === index+'modeOfPayment'?"fc3" : "fc2"} box-center`}>
                        Pending
                            
                          </p>
                        </th>}
                        <th className="cp">
                          <p className="box-center">Action</p>
                        </th>
                        <th>
                          <p className="box-center">Expand</p>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                     
                        <tr key={index}>
                          <td>{billingGroup.date}</td>
		    	{ billingGroup.discount> 0 &&
				<>
                          <td> {formatter.format(billingGroup.courseFee)}</td>
                          <td> {formatter.format(billingGroup.discount)}</td>
				</>
			}
                          <td> {formatter.format(billingGroup.sell_price)}</td>
                          <td> {formatter.format(billingGroup.paidAmount)}</td>
                          {billingGroup.pendingAmount>0  && <td> {formatter.format(billingGroup.pendingAmount)}</td>}
                          <td>
                                  {billingGroup.invoice > 0 ? (
                                    <p className="v-center jcsa pr" ref={dropdownRef}>
                                      <span
                                        className="fs12 ls1 lh22 fw6 bg-outline-success badge badge-status cp v-center"
                                        onClick={() => toggleDropdown(`${index}`, "invoice")}
                                      >
                                        <IoReceipt className="mr4 fs14" /> Invoice
                                      </span>

                                      {isDropdownOpen(`${index}`, "invoice") && (
                                        <div className="bill-menu">
                                          <p
                                            className="bill-item cp ls1"
                                            onClick={() => {
                                              if (billingGroup.invoice_name) {
                                                window.open(`${constant.invoicepdfurl}${billingGroup.invoice_name}`, '_blank');
                                                setDropdownOpen(null);
                                              } else {
                                                getInvoicePdfUrl(billingGroup.wo_id, 'view');
                                              }
                                            }}
                                            ref={viewRef}
                                          >
                                            <FaRegEye className="mr4 fc8 " /> View
                                          </p>
                                          {user.access_by_login <= 0 && (
                                            <p
                                              className="bill-item cp ls1"
                                              onClick={() => {
                                                if (billingGroup.invoice_name) {
                                                  handleDownloadReceiptFile(`${constant.invoicepdfurl}${billingGroup.invoice_name}`);
                                                } else {
                                                  getInvoicePdfUrl(billingGroup.wo_id, 'download');
                                                }
                                              }}
                                              ref={downloadRef}
                                            >
                                              <FaFileDownload className="mr4 fc8" /> Download
                                            </p>
                                          )}
                                          {user.access_by_login >0 && (
                                            <p
                                              className="bill-item cp ls1"
                                              onClick={() => {
                                                sendinvoicemail(billingGroup.wo_id, 'sendmail');
                                              }}
                                              ref={downloadRef}
                                            >
                                              <FaFileDownload className="mr4 fc8" /> Send Mail
                                            </p>
                                          )}
                                        </div>
                                      )}
                                    </p>
                                  ) : (
                                    <span>-</span> // Display hyphen if no invoice
                                  )}
                                </td>

                          <td onClick={() => toggleExpanded(index)} className="cp">
                            {expanded === index ? (
                              <MdExpandLess className="fs20" />
                            ) : (
                              <MdExpandMore className="fs20" />
                            )}
                          </td>
                        </tr>
                     
                      {expanded === index && (
                    <tr className="expanded-row">
                      <td colSpan="9">
                        <table className="w100 tac common-table">
                          <thead>
                            <tr>
                              <th>Payment Date</th>
                              <th>Type</th>
                              <th>Amount</th>
                              {/* <th>Payment Type</th> */}
                              <th>Payment Mode</th>
                              <th>Payment Status</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {billingGroup.courseBillings.map((bill, idx) => (
                              <tr key={idx}>
                                <td>{bill.date}</td>
                                <td>{bill.discount_type}</td>
                                <td>{formatter.format(bill.paidAmount)}</td>
                                {/* <td>{bill.payment_gateway_type}</td> */}
                                <td
                            style={{
                              color: giveTextColor(
                                bill.modeOfPayment === "Cash"
                                  ? "green"
                                  : bill.modeOfPayment === "Upi"
                                  ? "orange"
                                  : bill.modeOfPayment === "Credit Card"
                                  ? "red"
                                  : bill.modeOfPayment
                              ),
                              textTransform: "capitalize",
                            }}  
                          >
                            {bill.modeOfPayment}
                          </td>
                                
                                <td
                            style={{
                              color: giveTextColor(
                                bill.payment_gateway_status === "Success"
                                  ? "green"
                                  : bill.payment_gateway_status === "Under Review"
                                  ? "orange"
                                  : bill.payment_gateway_status === "Rejected"
                                  ? "red"
                                  : bill.payment_gateway_status
                              ),
                              textTransform: "capitalize",
                            }}
                            
                          >{bill.payment_gateway_status}</td>
                                <td
                                  className={`${
                                    !billingGroup.coursePendingAmt
                                      ? "bill-download3"
                                      : "bill-download2"
                                  }`}
                                >
                                  {bill.paidAmount > 0 && bill.payment_gateway_status == "Success" && bill.discount_type == "Payment" ? (
                                    <p
                                      className="v-center jcsa pr"
                                      ref={dropdownRef}
                                    >
                                      <span
                                        className="fs12 ls1 lh22 fw6  bg-outline-success badge badge-status cp v-center"
                                        onClick={() =>
                                          toggleDropdown(
                                            `${index}-${idx}`,
                                            "receipt"
                                          )
                                        }
                                      >
                                        <IoReceipt className="mr4 fs14" /> Receipt
                                      </span>
                                    
                                      
                                      {isDropdownOpen(`${index}-${idx}`, "receipt") && (
                                        <div className="bill-menu">
                                          <p
                                            className="bill-item cp ls1"
                                            onClick={() => {
                                              if (bill.payment_file_name) {
                                                window.open(`${constant.invoicepdfurl}${bill.payment_file_name}`, '_blank');
                                                setDropdownOpen(null);
                                              } else {
                                                getReceiptPdfUrl(bill.payment_id,'view');
                                              }
                                            }}
                                            ref={viewRef}
                                          >
                                            <FaRegEye className="mr4 fc8 " /> View
                                          </p>
                                          {user.access_by_login<=0 && <p
                                            className="bill-item cp ls1"
                                            onClick={() => {
                                              if (bill.payment_file_name) {
                                                handleDownloadReceiptFile(`${constant.invoicepdfurl}${bill.payment_file_name}`)                                    
                                              } else {
                                                getReceiptPdfUrl(bill.payment_id,'download');
                                              }
                                            }}
                                            ref={downloadRef}
                                          >
                                            <FaFileDownload className="mr4 fc8" />{" "}
                                            Download
                                          </p>}
                                          {user.access_by_login>0 && <p
                                            className="bill-item cp ls1"
                                            onClick={() => {
                                              sendreciptmail(bill.payment_id,'sendmail');
          
                                            }}
                                            ref={downloadRef}
                                          >
                                            <FaFileDownload className="mr4 fc8" />{" "}
                                            Send Mail
                                          </p>}
                                        </div>
                                      )}
                                      
                                      
                                    </p>
                                  ) : (
                                    <p className="fs12 fc6 ls1 lh22">--</p>
                                  )}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </td>
                    </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </>
            )}
           
          </div>
        ))}
         <ToastContainer position='bottom-right' />
        {courseBillingRecord.length===0 && (
          <div className="fs16 fc5 pl16 box-center">No Record Found</div>
        )}
      </div>
    </div>
    )}
     {!dataStatus && (<div className="box-center mb12">
      <SmallLoader className={"mb12"} />
  </div>)}
    </>
  );
};

export default Billings;
